import { type Common } from './common.js';
import { type PaginatedQueryOptions } from './models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from './models/pagination/PaginationResponse.type.js';
import {
  type CreateValues,
  type FindAllOptions,
  type StripeAccount,
  type UpdateValues,
} from './models/stripeAccount.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/stripe-accounts';
  }

  async findOneByAccountId(accountId: string): Promise<StripeAccount> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${accountId}`);
    const body = await this.common.getJSON(url);
    return body;
  }

  async findAllAccessible(livemode: boolean): Promise<{ name: string; accountId: string }[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/accessible`, {
      livemode,
    });
    const { accounts } = await this.common.getJSON(url);
    return accounts;
  }

  async findAll(): Promise<StripeAccount[]> {
    const url = this.common.constructPath(this.baseEndpoint);
    const { results } = await this.common.getJSON(url);
    return results;
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<StripeAccount>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<StripeAccount> {
    const url = this.common.constructPath(this.baseEndpoint);
    const body = await this.common.postJSON(url, values);
    return body;
  }

  async updateByAccountId(accountId: string, values: UpdateValues): Promise<StripeAccount> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${accountId}`);
    const body = await this.common.patchJSON(url, values);
    return body;
  }
}
